import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { ProcessService } from 'pages/standard-setup/processes/service';
import { DialogService } from 'aurelia-dialog';
import { formatTableLink, creatTableButton } from 'resources/utility';
import toastr from 'toastr';

@inject(ProcessService, DialogService, EventAggregator)
export class Statuses {
    constructor(processService, dialogService, ea) {
        this.ea = ea;
        this.processService = processService;
        this.dialogService = dialogService;

        this.columns = [
            { dataField: 'name', sortOrder: 'asc', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { dataField: 'unitOfMeasurementName', label: 'Unit of Measurement' },
            { dataField: 'isWeightBase' },
            { dataField: 'isSizeUsed' },
            { caption: 'Actions', cellTemplate: (container, options) => creatTableButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete }), allowExporting: false }
        ];

        this.subscription = this.ea.subscribe('processes:updated', () => {
            this.grid.refresh();
        });
    }

    deactivate () {
        this.subscription.dispose();
    }

    delete = (process) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.processService.delete(process.id);
                this.grid.refresh();
                toastr.success('Process was deleted!');
            }
        });
    };

    add() {
        this.dialogService.open({ viewModel: this.processService.editor });
    }

    edit = (data) => {
        this.dialogService.open({ viewModel: this.processService.editor, model: { id: data.id } });
    };
}